import React, { useState, useEffect } from 'react'
import {
  IonGrid,
  IonRow,
  IonButton,
  IonIcon,
  isPlatform
} from '@ionic/react'
import { Link, useParams } from 'react-router-dom'
import {
  chevronForwardOutline,
  chevronBackOutline
} from 'ionicons/icons'
import RssChapterCard from '../../../components/common/RssChapterCard'
import RssChapterCardSkeleton from '../../../components/skeletons/RssChapterCardSkeleton'
import Parser from 'rss-parser/dist/rss-parser'
import { corsProxy } from '../../../config/app'
import './styles.scss'

const RssReader = (props) => {
  const { setRssTrack, product } = props
  const { page } = useParams()
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({
    available: false,
    pages: 0,
    current: 1
  })
  const [xhr, setXhr] = useState('pending')
  const pageLength = 20

  useEffect(() => {
    if (typeof product !== 'undefined') {
      const parser = new Parser()
      const _page = page || 1
      let _corsProxy = ''
      if ((product.data.rss_url.includes('audioboom') && isPlatform('cordova')) ||
          (navigator.userAgent.match(/(iPad|iPhone|iPod|Macintosh)/i) && !isPlatform('cordova')) ||
          isPlatform('ios')) {
        _corsProxy = corsProxy
      }
      parser
        .parseURL(_corsProxy + product.data.rss_url + '/', (err, feed) => {
          if (err) {
            setPagination({
              available: false,
              pages: 0,
              current: 1
            })
            setData([])
            setXhr('rejected')
            throw err
          }
          const items = feed.items || []
          if (items.length > 0) {
            const pages = Math.ceil(items.length / pageLength)
            const start = pageLength * (_page - 1)
            const end = (pageLength * (_page - 1)) + pageLength
            const chapters = items.slice(start, end)
            const _pagination = {
              available: (pages > 0),
              pages: pages,
              current: _page
            }
            setPagination(_pagination)
            setData(chapters)
            setRssTrack(chapters[0])
          } else {
            setPagination({
              available: false,
              pages: 0,
              current: 1
            })
            setData([])
          }
          setXhr('accepted')
        })
    }
    return () => {
      setData([])
      setPagination({
        available: false,
        pages: 0,
        current: 1
      })
      setXhr('pending')
    }
  }, [product, page, setRssTrack])

  if (xhr === 'pending') {
    return (
      <div className='rss-reader loading'>
        <IonGrid>
          <IonRow>
            <RssChapterCardSkeleton />
            <RssChapterCardSkeleton />
            <RssChapterCardSkeleton />
            <RssChapterCardSkeleton />
            <RssChapterCardSkeleton />
            <RssChapterCardSkeleton />
          </IonRow>
        </IonGrid>
      </div>
    )
  } else {
    return (
      <div className='rss-reader'>
        {data.length === 0 && xhr === 'accepted' &&
          <div className='notify'>
            <h1>
              Parece que aún no hay nada para escuchar por acá
              <span role='img' aria-label='emoji sorprendido'> &#128551;</span>
            </h1>
            <p>Regresa pronto para disfrutar de lo mejor de <b>{product.data.product}</b></p>
          </div>}
        {data.length === 0 && xhr === 'rejected' &&
          <div className='notify'>
            <h1>
              Parece que ha ocurrido un error
              <span role='img' aria-label='emoji sorprendido'> &#128551;</span>
            </h1>
            <p>Regresa pronto para disfrutar de lo mejor de <b>{product.data.product}</b></p>
          </div>}
        {data.length > 0 &&
          <IonGrid>
            <IonRow>
              {data.map((chapter, index) => (
                <RssChapterCard key={index} chapter={chapter} rssTitle={product.data.url_name} />
              ))}
            </IonRow>
          </IonGrid>}
        {pagination?.available === true &&
          <section className='buttons-wrapper'>
            {pagination?.current > 1 &&
              <Link to={`/${product.data.category_alias}/${product.data.id}_${product.data.url_name}/${parseInt(pagination.current) - 1}`}>
                <IonButton className='previous'>
                  <IonIcon icon={chevronBackOutline} />
                </IonButton>
              </Link>}
            {pagination?.current < pagination?.pages &&
              <Link to={`/${product.data.category_alias}/${product.data.id}_${product.data.url_name}/${parseInt(pagination.current) + 1}`}>
                <IonButton className='next'>
                  <IonIcon icon={chevronForwardOutline} />
                </IonButton>
              </Link>}
          </section>}
      </div>
    )
  }
}

export default RssReader
